webpackJsonp([1],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);





var ENV = __webpack_require__(174);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var defaultState = {
    gallery: [],
    selectedImage: {
        image: {},
        position: "",
        pagination: []
    },
    currentPath: "",
    payload: {
        country: 'Please Choose One',
        code: []
    }
};

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultState),
    mutations: {
        setGallery: function setGallery(state, arr) {
            state.gallery = arr.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { pos: index });
            });
        },
        setSelectedImage: function setSelectedImage(state, obj) {
            state.selectedImage.image = obj[0];
            state.selectedImage.position = obj[1];
            state.selectedImage.pagination = [state.selectedImage.position - 1 != -1 ? state.gallery[state.selectedImage.position - 1] : false, state.selectedImage.position + 1 < state.gallery.length ? state.gallery[state.selectedImage.position + 1] : false];

            //TODO remove before launch
        },
        setCurrentPath: function setCurrentPath(state, str) {
            window.localStorage.setItem("currentPath", str);
            state.currentPath = str;
        }
    },
    actions: {
        updateGallery: function updateGallery(_ref, arr) {
            var commit = _ref.commit;

            commit('setGallery', arr);
        },
        updateSelectedImage: function updateSelectedImage(_ref2, obj) {
            var commit = _ref2.commit;

            commit('setSelectedImage', obj);
        },
        updateCurrentPath: function updateCurrentPath(_ref3, str) {
            var commit = _ref3.commit;

            commit('setCurrentPath', str);
        }
    }

});

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Logo__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GalleryItem__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdItem__ = __webpack_require__(120);

//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'home',
    components: {
        Logo: __WEBPACK_IMPORTED_MODULE_4__Logo__["a" /* default */],
        GalleryItem: __WEBPACK_IMPORTED_MODULE_5__GalleryItem__["a" /* default */],
        AdItem: __WEBPACK_IMPORTED_MODULE_6__AdItem__["a" /* default */]
    },
    data: function data() {
        return {
            wpData: null,
            galleryContent: [],
            test: this.$store
        };
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://admin.ad.arbor.design/index.php/wp-json/wp/v2/posts?slug=home-page').then(function (res) {
            // take the gallery content response and set it to global state
            _this.$store.dispatch("updateGallery", res.data[0].acf.gallery);

            // set wpData to initial acf content
            _this.wpData = res.data[0].acf;

            // set gallery content specifically to the acf gallery array
            // this.galleryContent = res.data[0].acf.gallery;
            res.data[0].acf.gallery.forEach(function (item, index) {
                setTimeout(function () {
                    _this.galleryContent.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { pos: index }));
                }, 150 * index);
            });
        });
    },

    watch: {
        $route: function $route(to, from) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://admin.ad.arbor.design/index.php/wp-json/wp/v2/posts?slug=home-page').then(function (res) {
                _this2.$store.dispatch("updateGallery", res.data[0].acf.gallery);
                _this2.wpData = res.data[0].acf;
                res.data[0].acf.gallery.forEach(function (item, index) {
                    setTimeout(function () {
                        _this2.galleryContent.push(item);
                    }, 200 * index);
                });
            });
        }
    },
    methods: {
        triggerDL: function triggerDL() {
            _fetch();
        }
    }
});

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryItem_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ad78c8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryItem_vue__ = __webpack_require__(277);
function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ad78c8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GalleryItem',
  props: ['data', 'isDownloadable', 'position'],
  methods: {
    setImage: function setImage(obj, pos) {
      this.$store.dispatch('updateSelectedImage', [obj, pos]);
    }
  },
  mounted: function mounted() {
    window.dispatchEvent(new Event('lazy-load'));
  }
});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdItem_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_334f3808_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdItem_vue__ = __webpack_require__(279);
function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_334f3808_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdItem',
  props: ['data']
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Logo__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GalleryItem__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AdItem__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_blob_util__ = __webpack_require__(132);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var _fetch = function _fetch() {
    fetch('https://admin.ad.arbor.design/wp-json/timex-american-documents/v1/redeem', {
        method: "POST",
        body: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            "code": "4c3b8bab-f51c-4fb2-88f6-3736a13dd334",
            "gallery": "Northeast",
            "document": 101,
            "email": "nick@nickstein.net",
            "purchase_location": "Some Store"
        }),
        headers: { 'Content-Type': 'application/json' }
    }).then(function (response) {
        return response.json();
    });
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'home',
    components: {
        Logo: __WEBPACK_IMPORTED_MODULE_6__Logo__["a" /* default */],
        GalleryItem: __WEBPACK_IMPORTED_MODULE_7__GalleryItem__["a" /* default */],
        AdItem: __WEBPACK_IMPORTED_MODULE_8__AdItem__["a" /* default */]
    },
    data: function data() {
        return {
            wpData: null,
            galleryContent: [],
            loading: false
        };
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var param, f;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            _this.loading = true;

                            param = _this.$route.path == "/" ? "home-page" : _this.$route.params.gallery;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://admin.ad.arbor.design/index.php/wp-json/wp/v2/posts?slug=' + param).then(function (res) {

                                // set wpData to initial acf content
                                _this.wpData = res.data[0].acf;

                                // set gallery content specifically to the acf gallery array
                                // this.galleryContent = res.data[0].acf.gallery;
                                _this.galleryContent = res.data[0].acf.gallery.map(function (item, index) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
                                        pos: index,
                                        dl: res.data[0].acf.is_content_downloadable
                                    });
                                });

                                // take the gallery content response and set it to global state
                                _this.$store.dispatch("updateGallery", _this.galleryContent);

                                // take the current routes path and set it to the global state
                                _this.$store.dispatch("updateCurrentPath", _this.$route.path);
                            });

                        case 4:
                            f = _context.sent;
                            _context.next = 7;
                            return f;

                        case 7:
                            _this.loading = false;

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    watch: {
        $route: function $route(to, from) {
            var _this2 = this;

            setTimeout(function () {
                return window.dispatchEvent(new Event('lazy-load'));
            }, 1000);

            this.loading = true;

            setTimeout(function () {
                _this2.loading = false;
            }, 400);

            var param = this.$route.path == "/" ? "home-page" : this.$route.params.gallery;

            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://admin.ad.arbor.design/index.php/wp-json/wp/v2/posts?slug=' + param).then(function (res) {

                // set wpData to initial acf content
                _this2.wpData = res.data[0].acf;

                // set gallery content specifically to the acf gallery array
                // this.galleryContent = res.data[0].acf.gallery;
                _this2.galleryContent = res.data[0].acf.gallery.map(function (item, index) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
                        pos: index,
                        dl: res.data[0].acf.is_content_downloadable
                    });
                });

                // take the gallery content response and set it to global state
                _this2.$store.dispatch("updateGallery", _this2.galleryContent);
                _this2.$store.dispatch("updateCurrentPath", _this2.$route.path);
            });

            // this.loading = false;
        }
    },
    methods: {
        triggerDL: function triggerDL() {
            _fetch();
        }
    }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Thumbnail_vue__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Check_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blob_util__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__countrydata_js__ = __webpack_require__(324);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ImageView',
    props: ['d'],
    components: { Thumbnail: __WEBPACK_IMPORTED_MODULE_6__Thumbnail_vue__["a" /* default */], Check: __WEBPACK_IMPORTED_MODULE_7__Check_vue__["a" /* default */] },
    data: function data() {
        return {
            data: this.$store.state.selectedImage,
            gallery: this.$store.state.gallery,
            currentPath: this.$store.state.currentPath,
            modal: false,
            payload: {
                country: 'Please Choose One',
                code: []
            },
            downloading: false,
            success: false,
            codeError: false,
            countryError: false,
            availableCountries: __WEBPACK_IMPORTED_MODULE_9__countrydata_js__["a" /* isoCountries */]
        };
    },

    watch: {
        $route: function $route(to, from) {
            var path = window.localStorage.getItem("currentPath");
            this.$store.dispatch("updateCurrentPath", path);
        }
    },
    computed: {
        state: function state() {
            this.payload.document = this.$store.state.selectedImage.image.download_document_number;
        }
    },
    created: function created() {
        if (!this.data.pagination.length) {
            this.$router.push(window.localStorage.getItem("currentPath"));
        }
        this.payload.document = this.$store.state.selectedImage.image.download_document_number;
        this.payload.gallery = window.localStorage.getItem("currentPath");
    },

    methods: {
        download: function download() {
            var _this = this;

            this.codeError = false;
            this.countryError = false;

            if (this.payload.country == 'Please Choose One') {
                this.countryError = true;
                return;
            }

            var p = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.payload, {
                document: parseInt(this.payload.document),
                // removing the '/' along with '-' and converting to title-case
                gallery: this.currentPath === '/' ? 'All Documents' : this.payload.gallery.slice(1, this.payload.gallery.length).split("-").map(function (item) {
                    return item[0].toUpperCase() + item.slice(1, item.length);
                }).join(" "),
                // converting array of 6 numbers to string
                code: this.payload.code.toString().split(',').join('')
            });

            var getPrint = function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    var f;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _this.downloading = true;
                                    _context.next = 3;
                                    return __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                                        method: 'post',
                                        url: 'https://admin.ad.arbor.design/wp-json/timex-american-documents/v1/redeem',
                                        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, p)
                                    }).then(function (response) {
                                        if (response.data.success == true) {
                                            _this.success = true;
                                        }

                                        if (response.data.success == 'false') {
                                            console.log('response is bad');
                                            response.data.reasons.forEach(function (item) {
                                                item == "BAD_CODE" ? _this.codeError = true : '';
                                            });
                                        }
                                        if (response.data.success === true) {
                                            _this.$ga.event({
                                                dimension1: p.code,
                                                dimension2: p.gallery,
                                                dimension3: p.purchase_location,
                                                dimension4: p.document.toString(),
                                                dimension5: p.country,
                                                eventCategory: 'americandocuments',
                                                eventAction: 'redeem',
                                                eventLabel: 'Code Redemption',
                                                eventValue: 1
                                            });
                                            var blob = Object(__WEBPACK_IMPORTED_MODULE_8_blob_util__["a" /* base64StringToBlob */])(response.data.base64_image, 'image/jpeg');
                                            var element = document.createElement('a');
                                            element.setAttribute('href', URL.createObjectURL(blob));
                                            element.setAttribute('download', response.data.filename);
                                            element.click();
                                        }
                                    }).catch(function (error) {
                                        console.log(error);
                                    });

                                case 3:
                                    f = _context.sent;
                                    _context.next = 6;
                                    return f;

                                case 6:
                                    _this.downloading = false;

                                case 7:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function getPrint() {
                    return _ref.apply(this, arguments);
                };
            }();

            getPrint();
        },
        openModal: function openModal() {
            this.modal = !this.modal;
            setTimeout(function () {
                return window.dispatchEvent(new Event('input-auto-advance'));
            }, 200);
        }
    }
});

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Thumbnail',
  props: ['data', 'isDownloadable', 'position'],
  methods: {
    setImage: function setImage(obj, pos) {
      this.$store.dispatch('updateSelectedImage', [obj, pos]);
    }
  }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'check',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// Vue.config.productionTip = false

// Invoke analytics: 
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
  id: 'UA-128590636-1',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
  /* autoTracking: {
    screenview: true
  } */
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */]
});

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d33c7a42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(272);
function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d33c7a42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 276.46 130.72"}},[_c('defs'),_c('title',[_vm._v("TIMEX_AD_PrimaryLogo_black")]),_c('path',{attrs:{"fill":"#fff","d":"M320.34,240.64v4h11.12v24h5.2v-24H348v-4Zm36.49,0v28h5l.05-27.87v-.15Zm40.54,0-7.25,17.93-7.32-17.83,0-.1h-4.95l-4.31,28h5l2.81-18.3,7.43,18.3h2.81l7.39-18.29,2.84,18.29h5.06l-4.66-27.89,0-.13Zm20.4,0,0,28h22.91v-4.35h-18v-8.15H438.4v-4h-15.7v-7.07h18.07v-4.43Zm51,0-6.42,9.16L456,240.71l-.05-.07h-6.37L459,253.92l-10.46,14.74h6.37l7.43-11.47,7.37,11.4.05.07h6.37l-10.49-14.74,9.51-13.28Z","transform":"translate(-257.77 -240.64)"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#fff","d":"M302,313.39l-7.75-17.23-7.8,17.23Zm-8.77-19.66h2.11l13.74,30h-2.4L303,315.39H285.55l-3.75,8.34h-2.28Z","transform":"translate(-257.77 -240.64)"}}),_c('polygon',{staticClass:"cls-1",attrs:{"fill":"#fff","points":"57.58 53.31 59.64 53.31 71.49 70.93 83.33 53.31 85.4 53.31 85.4 83.1 83.2 83.1 83.2 57.22 71.53 74.37 71.36 74.37 59.69 57.22 59.69 83.1 57.58 83.1 57.58 53.31"}}),_c('polygon',{staticClass:"cls-1",attrs:{"fill":"#fff","points":"94.16 53.31 115.15 53.31 115.15 55.35 96.35 55.35 96.35 67.05 113.25 67.05 113.25 69.1 96.35 69.1 96.35 81.05 115.36 81.05 115.36 83.1 94.16 83.1 94.16 53.31"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#fff","d":"M392.3,309.39c4.93,0,8.6-2.51,8.6-6.8v-.09c0-4-3.12-6.51-8.47-6.51H382.36v13.4ZM380.16,294h12.39c3.63,0,6.54,1.15,8.31,2.93a7.91,7.91,0,0,1,2.23,5.53v.09c0,5-3.67,7.83-8.64,8.51l9.74,12.72h-2.78L392,311.39h-9.65v12.34h-2.2Z","transform":"translate(-257.77 -240.64)"}}),_c('rect',{staticClass:"cls-1",attrs:{"fill":"#fff","x":"153.16","y":"53.31","width":"2.19","height":"29.79"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#fff","d":"M420.87,308.93v-.09c0-8.43,6.24-15.4,14.75-15.4,5.27,0,8.43,1.95,11.47,4.76l-1.56,1.62c-2.57-2.51-5.52-4.38-9.95-4.38-7.08,0-12.43,5.83-12.43,13.31v.09c0,7.53,5.44,13.4,12.47,13.4,4.26,0,7.17-1.66,10.16-4.63l1.48,1.44c-3.12,3.11-6.49,5.19-11.72,5.19-8.43,0-14.67-6.76-14.67-15.31","transform":"translate(-257.77 -240.64)"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#fff","d":"M473.26,313.39l-7.76-17.23-7.79,17.23Zm-8.77-19.66h2.11l13.74,30h-2.4l-3.76-8.34h-17.4L453,323.73h-2.28Z","transform":"translate(-257.77 -240.64)"}}),_c('polygon',{staticClass:"cls-1",attrs:{"fill":"#fff","points":"228.81 53.31 230.87 53.31 251.23 79.22 251.23 53.31 253.34 53.31 253.34 83.1 251.69 83.1 230.91 56.63 230.91 83.1 228.81 83.1 228.81 53.31"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#fff","d":"M267.59,368.81c8.22,0,13.4-5.66,13.4-12.77V356c0-7.07-5.18-12.85-13.4-12.85H260v25.7Zm-9.82-27.74h9.82c9.27,0,15.68,6.42,15.68,14.8V356c0,8.38-6.41,14.89-15.68,14.89h-9.82Z","transform":"translate(-257.77 -240.64)"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#fff","d":"M316.81,356V356c0-7.36-5.31-13.4-12.6-13.4s-12.52,5.95-12.52,13.31V356c0,7.36,5.31,13.4,12.6,13.4s12.52-5.95,12.52-13.32m-27.39,0V356c0-8.13,5.94-15.41,14.87-15.41s14.8,7.2,14.8,15.32c0,.05,0,.05,0,.09,0,8.13-5.94,15.4-14.88,15.4s-14.79-7.19-14.79-15.32","transform":"translate(-257.77 -240.64)"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#fff","d":"M325.24,356V356c0-8.43,6.24-15.41,14.75-15.41,5.27,0,8.43,2,11.46,4.77l-1.56,1.62c-2.57-2.51-5.52-4.38-9.94-4.38-7.08,0-12.43,5.83-12.43,13.31V356c0,7.53,5.43,13.4,12.47,13.4,4.26,0,7.17-1.66,10.16-4.63l1.47,1.44c-3.12,3.11-6.49,5.19-11.71,5.19-8.43,0-14.67-6.76-14.67-15.32","transform":"translate(-257.77 -240.64)"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#fff","d":"M357.18,358.47v-17.4h2.2v17.19c0,7,3.75,11.06,10,11.06,6,0,9.82-3.66,9.82-10.85v-17.4h2.2v17.14c0,8.56-4.94,13.11-12.1,13.11s-12.1-4.51-12.1-12.85","transform":"translate(-257.77 -240.64)"}}),_c('polygon',{staticClass:"cls-1",attrs:{"fill":"#fff","points":"157.66 100.43 145.82 118.04 133.97 100.43 131.91 100.43 131.91 130.21 134.01 130.21 134.01 104.34 145.69 121.49 145.86 121.49 157.53 104.34 157.53 130.21 159.72 130.21 159.72 100.43 157.66 100.43"}}),_c('polygon',{staticClass:"cls-1",attrs:{"fill":"#fff","points":"167.88 100.43 167.88 130.21 189.08 130.21 189.08 128.17 170.07 128.17 170.07 116.21 186.97 116.21 186.97 114.17 170.07 114.17 170.07 102.47 188.87 102.47 188.87 100.43 167.88 100.43"}}),_c('polygon',{staticClass:"cls-1",attrs:{"fill":"#fff","points":"218.53 100.43 218.53 126.34 198.18 100.43 196.11 100.43 196.11 130.21 198.22 130.21 198.22 103.75 219 130.21 220.64 130.21 220.64 100.43 218.53 100.43"}}),_c('polygon',{staticClass:"cls-1",attrs:{"fill":"#fff","points":"227.3 100.43 227.3 102.47 237.58 102.47 237.58 130.21 239.77 130.21 239.77 102.47 250.06 102.47 250.06 100.43 227.3 100.43"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"#fff","d":"M512.57,366.51l1.43-1.66c3.25,3,6.24,4.43,10.58,4.43s7.46-2.51,7.46-5.92v-.08c0-3.15-1.64-5-8.34-6.34-7.08-1.45-10-3.87-10-8.38v-.09c0-4.43,4-7.83,9.48-7.83a14.61,14.61,0,0,1,10.12,3.62L532,346a12.66,12.66,0,0,0-8.81-3.36c-4.34,0-7.21,2.51-7.21,5.62v.08c0,3.15,1.6,5.07,8.6,6.51,6.83,1.41,9.69,3.87,9.69,8.21v.09c0,4.81-4.09,8.13-9.78,8.13a16.7,16.7,0,0,1-11.88-4.77","transform":"translate(-257.77 -240.64)"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const merge = __webpack_require__(175)
const prodEnv = __webpack_require__(271)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('header',[_c('div',{staticClass:"header-inner-wrapper"},[_c('div',{staticClass:"logo mv2"},[_c('Logo')],1),_vm._v(" "),_vm._m(0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wrapper",class:{ 'wrapper-no-header': !_vm.showHeader }},[_c('nav',[_c('div',{staticClass:"nav-list-wrapper"},[_c('ul',{staticClass:"nav-list"},[_c('li',[_c('router-link',{staticClass:"nav-item",class:{ 'active' : _vm.path == '/' },attrs:{"to":"/"}},[_vm._v("ALL DOCUMENTS")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"nav-item",class:{ 'active' : _vm.path == '/desert-west' },attrs:{"to":"/desert-west"}},[_vm._v("DESERT WEST")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"nav-item",class:{ 'active' : _vm.path == '/north-east' },attrs:{"to":"/north-east"}},[_vm._v("NORTH EAST")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"nav-item",class:{ 'active' : _vm.path == '/mountain-west' },attrs:{"to":"/mountain-west"}},[_vm._v("MOUNTAIN WEST")])],1)])])]),_vm._v(" "),_c('main',{staticClass:"contain"},[_c('transition',{attrs:{"name":"list"}},[_c('router-view')],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"regular mv2"},[_vm._v("We brought watchmaking back to the USA. Each watch in the collection documents American craftsmanship and ingenuity. For this gallery, we worked with photographer Bryan Schutmaat, to document the diverse American landscape and culture that inspires us.")]),_vm._v(" "),_c('a',{staticClass:"animated-button learn-more-btn",attrs:{"href":"https://www.timex.com/browse/collections/american-documents/"}},[_vm._v("Learn More")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GalleryView__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ImageView__ = __webpack_require__(316);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  // TODO: this will be needed for identifying scroll behavior 
  // on specific viewport resolution. currently in POC... need to
  // get critical tasks done first for launch then I can focus on this.

  // scrollBehavior (to, from, savedPosition) {
  //     if(window.outerWidth > 1200) {
  //         return new Promise((resolve, reject) => {
  //             setTimeout(() => {
  //               resolve({ x: 0, y: 400 })
  //             }, 500)
  //         })
  //     }
  // },
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_GalleryView__["a" /* default */]
  }, {
    path: '/:gallery',
    component: __WEBPACK_IMPORTED_MODULE_3__components_GalleryView__["a" /* default */]
  }, {
    path: '/detail/:number',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ImageView__["a" /* default */]
  }]
}));

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(117);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e1b8cfd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(280);
function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e1b8cfd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-item"},[_c('div',{staticClass:"gallery-item-inner",on:{"click":function($event){_vm.setImage(_vm.data,_vm.data.pos)}}},[_c('router-link',{attrs:{"to":("/detail/" + (_vm.data.name))},on:{"click":function($event){_vm.setImage(_vm.data)}}},[_c('div',{staticClass:"image",staticStyle:{"background-position":"100% 80%","background-size":"cover"},style:({ backgroundImage: ("url('" + (_vm.data.image) + "')") })},[_c('img',{staticClass:"hidden",attrs:{"src":_vm.data.image,"alt":'American Documents image of ' + _vm.data.name + ' ' + _vm.data.document_number}})]),_vm._v(" "),_c('span',{staticClass:"not-visible"},[_vm._v(_vm._s(_vm.data.name))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h5',{staticClass:"image-title mt3 regular"},[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),_c('span',{staticClass:"document-number heavy"},[_vm._v(_vm._s(_vm.data.document_number))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-item"},[_c('div',{staticClass:"gallery-item-inner"},[_c('a',{attrs:{"href":""}},[_c('div',{staticClass:"image",staticStyle:{"background-position":"center","background-size":"cover"},style:({ backgroundImage: 'url(' + _vm.data.image + ')' })},[_c('img',{staticClass:"hidden",attrs:{"src":_vm.data.image,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('button',[_vm._v(_vm._s(_vm.data.button_text))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"tag":"div","name":"list"}},_vm._l((_vm.galleryContent),function(item,index){return _c(item.acf_fc_layout,{key:index,tag:"component",attrs:{"data":item,"position":index}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryView_vue__ = __webpack_require__(122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6629f294_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryView_vue__ = __webpack_require__(315);
function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6629f294_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',_vm._l((_vm.galleryContent),function(item,index){return _c(item.acf_fc_layout,{key:index,tag:"component",attrs:{"data":item,"isDownloadable":_vm.wpData.is_content_downloadable,"position":index}})})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageView_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29179c98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageView_vue__ = __webpack_require__(325);
function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29179c98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29179c98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Thumbnail_vue__ = __webpack_require__(134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee572ab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Thumbnail_vue__ = __webpack_require__(320);
function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ee572ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Thumbnail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee572ab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Thumbnail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail"},[(_vm.data !== false)?_c('div',{staticClass:"thumbnail-image",style:({ backgroundImage: 'url(' + _vm.data.image + ')' }),on:{"click":function($event){_vm.setImage(_vm.data,_vm.data.pos)}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505a82b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check_vue__ = __webpack_require__(323);
function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-505a82b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505a82b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 322:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{staticStyle:{"enable-background":"new 0 0 52 52"},attrs:{"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 52 52","xml:space":"preserve"}},[_c('g',[_c('path',{attrs:{"d":"M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26\n    S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M38.252,15.336l-15.369,17.29l-9.259-7.407c-0.43-0.345-1.061-0.274-1.405,0.156c-0.345,0.432-0.275,1.061,0.156,1.406\n    l10,8C22.559,34.928,22.78,35,23,35c0.276,0,0.551-0.114,0.748-0.336l16-18c0.367-0.412,0.33-1.045-0.083-1.411\n    C39.251,14.885,38.62,14.922,38.252,15.336z"}})])]),_vm._v(" "),_c('p',{staticClass:"thank-you"},[_vm._v("Thank you for your download")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoCountries; });
var isoCountries = [{ id: 'AF', text: 'Afghanistan' }, { id: 'AX', text: 'Aland Islands' }, { id: 'AL', text: 'Albania' }, { id: 'DZ', text: 'Algeria' }, { id: 'AS', text: 'American Samoa' }, { id: 'AD', text: 'Andorra' }, { id: 'AO', text: 'Angola' }, { id: 'AI', text: 'Anguilla' }, { id: 'AQ', text: 'Antarctica' }, { id: 'AG', text: 'Antigua And Barbuda' }, { id: 'AR', text: 'Argentina' }, { id: 'AM', text: 'Armenia' }, { id: 'AW', text: 'Aruba' }, { id: 'AU', text: 'Australia' }, { id: 'AT', text: 'Austria' }, { id: 'AZ', text: 'Azerbaijan' }, { id: 'BS', text: 'Bahamas' }, { id: 'BH', text: 'Bahrain' }, { id: 'BD', text: 'Bangladesh' }, { id: 'BB', text: 'Barbados' }, { id: 'BY', text: 'Belarus' }, { id: 'BE', text: 'Belgium' }, { id: 'BZ', text: 'Belize' }, { id: 'BJ', text: 'Benin' }, { id: 'BM', text: 'Bermuda' }, { id: 'BT', text: 'Bhutan' }, { id: 'BO', text: 'Bolivia' }, { id: 'BA', text: 'Bosnia And Herzegovina' }, { id: 'BW', text: 'Botswana' }, { id: 'BV', text: 'Bouvet Island' }, { id: 'BR', text: 'Brazil' }, { id: 'IO', text: 'British Indian Ocean Territory' }, { id: 'BN', text: 'Brunei Darussalam' }, { id: 'BG', text: 'Bulgaria' }, { id: 'BF', text: 'Burkina Faso' }, { id: 'BI', text: 'Burundi' }, { id: 'KH', text: 'Cambodia' }, { id: 'CM', text: 'Cameroon' }, { id: 'CA', text: 'Canada' }, { id: 'CV', text: 'Cape Verde' }, { id: 'KY', text: 'Cayman Islands' }, { id: 'CF', text: 'Central African Republic' }, { id: 'TD', text: 'Chad' }, { id: 'CL', text: 'Chile' }, { id: 'CN', text: 'China' }, { id: 'CX', text: 'Christmas Island' }, { id: 'CC', text: 'Cocos (Keeling) Islands' }, { id: 'CO', text: 'Colombia' }, { id: 'KM', text: 'Comoros' }, { id: 'CG', text: 'Congo' }, { id: 'CD', text: 'Congo}, Democratic Republic' }, { id: 'CK', text: 'Cook Islands' }, { id: 'CR', text: 'Costa Rica' }, { id: 'CI', text: 'Cote D\'Ivoire' }, { id: 'HR', text: 'Croatia' }, { id: 'CU', text: 'Cuba' }, { id: 'CY', text: 'Cyprus' }, { id: 'CZ', text: 'Czech Republic' }, { id: 'DK', text: 'Denmark' }, { id: 'DJ', text: 'Djibouti' }, { id: 'DM', text: 'Dominica' }, { id: 'DO', text: 'Dominican Republic' }, { id: 'EC', text: 'Ecuador' }, { id: 'EG', text: 'Egypt' }, { id: 'SV', text: 'El Salvador' }, { id: 'GQ', text: 'Equatorial Guinea' }, { id: 'ER', text: 'Eritrea' }, { id: 'EE', text: 'Estonia' }, { id: 'ET', text: 'Ethiopia' }, { id: 'FK', text: 'Falkland Islands (Malvinas)' }, { id: 'FO', text: 'Faroe Islands' }, { id: 'FJ', text: 'Fiji' }, { id: 'FI', text: 'Finland' }, { id: 'FR', text: 'France' }, { id: 'GF', text: 'French Guiana' }, { id: 'PF', text: 'French Polynesia' }, { id: 'TF', text: 'French Southern Territories' }, { id: 'GA', text: 'Gabon' }, { id: 'GM', text: 'Gambia' }, { id: 'GE', text: 'Georgia' }, { id: 'DE', text: 'Germany' }, { id: 'GH', text: 'Ghana' }, { id: 'GI', text: 'Gibraltar' }, { id: 'GR', text: 'Greece' }, { id: 'GL', text: 'Greenland' }, { id: 'GD', text: 'Grenada' }, { id: 'GP', text: 'Guadeloupe' }, { id: 'GU', text: 'Guam' }, { id: 'GT', text: 'Guatemala' }, { id: 'GG', text: 'Guernsey' }, { id: 'GN', text: 'Guinea' }, { id: 'GW', text: 'Guinea-Bissau' }, { id: 'GY', text: 'Guyana' }, { id: 'HT', text: 'Haiti' }, { id: 'HM', text: 'Heard Island & Mcdonald Islands' }, { id: 'VA', text: 'Holy See (Vatican City State)' }, { id: 'HN', text: 'Honduras' }, { id: 'HK', text: 'Hong Kong' }, { id: 'HU', text: 'Hungary' }, { id: 'IS', text: 'Iceland' }, { id: 'IN', text: 'India' }, { id: 'ID', text: 'Indonesia' }, { id: 'IR', text: 'Iran}, Islamic Republic Of' }, { id: 'IQ', text: 'Iraq' }, { id: 'IE', text: 'Ireland' }, { id: 'IM', text: 'Isle Of Man' }, { id: 'IL', text: 'Israel' }, { id: 'IT', text: 'Italy' }, { id: 'JM', text: 'Jamaica' }, { id: 'JP', text: 'Japan' }, { id: 'JE', text: 'Jersey' }, { id: 'JO', text: 'Jordan' }, { id: 'KZ', text: 'Kazakhstan' }, { id: 'KE', text: 'Kenya' }, { id: 'KI', text: 'Kiribati' }, { id: 'KR', text: 'Korea' }, { id: 'KW', text: 'Kuwait' }, { id: 'KG', text: 'Kyrgyzstan' }, { id: 'LA', text: 'Lao People\'s Democratic Republic' }, { id: 'LV', text: 'Latvia' }, { id: 'LB', text: 'Lebanon' }, { id: 'LS', text: 'Lesotho' }, { id: 'LR', text: 'Liberia' }, { id: 'LY', text: 'Libyan Arab Jamahiriya' }, { id: 'LI', text: 'Liechtenstein' }, { id: 'LT', text: 'Lithuania' }, { id: 'LU', text: 'Luxembourg' }, { id: 'MO', text: 'Macao' }, { id: 'MK', text: 'Macedonia' }, { id: 'MG', text: 'Madagascar' }, { id: 'MW', text: 'Malawi' }, { id: 'MY', text: 'Malaysia' }, { id: 'MV', text: 'Maldives' }, { id: 'ML', text: 'Mali' }, { id: 'MT', text: 'Malta' }, { id: 'MH', text: 'Marshall Islands' }, { id: 'MQ', text: 'Martinique' }, { id: 'MR', text: 'Mauritania' }, { id: 'MU', text: 'Mauritius' }, { id: 'YT', text: 'Mayotte' }, { id: 'MX', text: 'Mexico' }, { id: 'FM', text: 'Micronesia}, Federated States Of' }, { id: 'MD', text: 'Moldova' }, { id: 'MC', text: 'Monaco' }, { id: 'MN', text: 'Mongolia' }, { id: 'ME', text: 'Montenegro' }, { id: 'MS', text: 'Montserrat' }, { id: 'MA', text: 'Morocco' }, { id: 'MZ', text: 'Mozambique' }, { id: 'MM', text: 'Myanmar' }, { id: 'NA', text: 'Namibia' }, { id: 'NR', text: 'Nauru' }, { id: 'NP', text: 'Nepal' }, { id: 'NL', text: 'Netherlands' }, { id: 'AN', text: 'Netherlands Antilles' }, { id: 'NC', text: 'New Caledonia' }, { id: 'NZ', text: 'New Zealand' }, { id: 'NI', text: 'Nicaragua' }, { id: 'NE', text: 'Niger' }, { id: 'NG', text: 'Nigeria' }, { id: 'NU', text: 'Niue' }, { id: 'NF', text: 'Norfolk Island' }, { id: 'MP', text: 'Northern Mariana Islands' }, { id: 'NO', text: 'Norway' }, { id: 'OM', text: 'Oman' }, { id: 'PK', text: 'Pakistan' }, { id: 'PW', text: 'Palau' }, { id: 'PS', text: 'Palestinian Territory}, Occupied' }, { id: 'PA', text: 'Panama' }, { id: 'PG', text: 'Papua New Guinea' }, { id: 'PY', text: 'Paraguay' }, { id: 'PE', text: 'Peru' }, { id: 'PH', text: 'Philippines' }, { id: 'PN', text: 'Pitcairn' }, { id: 'PL', text: 'Poland' }, { id: 'PT', text: 'Portugal' }, { id: 'PR', text: 'Puerto Rico' }, { id: 'QA', text: 'Qatar' }, { id: 'RE', text: 'Reunion' }, { id: 'RO', text: 'Romania' }, { id: 'RU', text: 'Russian Federation' }, { id: 'RW', text: 'Rwanda' }, { id: 'BL', text: 'Saint Barthelemy' }, { id: 'SH', text: 'Saint Helena' }, { id: 'KN', text: 'Saint Kitts And Nevis' }, { id: 'LC', text: 'Saint Lucia' }, { id: 'MF', text: 'Saint Martin' }, { id: 'PM', text: 'Saint Pierre And Miquelon' }, { id: 'VC', text: 'Saint Vincent And Grenadines' }, { id: 'WS', text: 'Samoa' }, { id: 'SM', text: 'San Marino' }, { id: 'ST', text: 'Sao Tome And Principe' }, { id: 'SA', text: 'Saudi Arabia' }, { id: 'SN', text: 'Senegal' }, { id: 'RS', text: 'Serbia' }, { id: 'SC', text: 'Seychelles' }, { id: 'SL', text: 'Sierra Leone' }, { id: 'SG', text: 'Singapore' }, { id: 'SK', text: 'Slovakia' }, { id: 'SI', text: 'Slovenia' }, { id: 'SB', text: 'Solomon Islands' }, { id: 'SO', text: 'Somalia' }, { id: 'ZA', text: 'South Africa' }, { id: 'GS', text: 'South Georgia And Sandwich Isl.' }, { id: 'ES', text: 'Spain' }, { id: 'LK', text: 'Sri Lanka' }, { id: 'SD', text: 'Sudan' }, { id: 'SR', text: 'Suriname' }, { id: 'SJ', text: 'Svalbard And Jan Mayen' }, { id: 'SZ', text: 'Swaziland' }, { id: 'SE', text: 'Sweden' }, { id: 'CH', text: 'Switzerland' }, { id: 'SY', text: 'Syrian Arab Republic' }, { id: 'TW', text: 'Taiwan' }, { id: 'TJ', text: 'Tajikistan' }, { id: 'TZ', text: 'Tanzania' }, { id: 'TH', text: 'Thailand' }, { id: 'TL', text: 'Timor-Leste' }, { id: 'TG', text: 'Togo' }, { id: 'TK', text: 'Tokelau' }, { id: 'TO', text: 'Tonga' }, { id: 'TT', text: 'Trinidad And Tobago' }, { id: 'TN', text: 'Tunisia' }, { id: 'TR', text: 'Turkey' }, { id: 'TM', text: 'Turkmenistan' }, { id: 'TC', text: 'Turks And Caicos Islands' }, { id: 'TV', text: 'Tuvalu' }, { id: 'UG', text: 'Uganda' }, { id: 'UA', text: 'Ukraine' }, { id: 'AE', text: 'United Arab Emirates' }, { id: 'GB', text: 'United Kingdom' }, { id: 'US', text: 'United States' }, { id: 'UM', text: 'United States Outlying Islands' }, { id: 'UY', text: 'Uruguay' }, { id: 'UZ', text: 'Uzbekistan' }, { id: 'VU', text: 'Vanuatu' }, { id: 'VE', text: 'Venezuela' }, { id: 'VN', text: 'Viet Nam' }, { id: 'VG', text: 'Virgin Islands, British' }, { id: 'VI', text: 'Virgin Islands, U.S.' }, { id: 'WF', text: 'Wallis And Futuna' }, { id: 'EH', text: 'Western Sahara' }, { id: 'YE', text: 'Yemen' }, { id: 'ZM', text: 'Zambia' }, { id: 'ZW', text: 'Zimbabwe' }];

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.modal == true)?_c('div',{staticClass:"overlay",on:{"click":function($event){_vm.openModal()}}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[(_vm.modal == true)?_c('div',[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-header",staticStyle:{"background-position":"center","background-size":"cover"},style:({ backgroundImage: 'url(' + _vm.data.image.image + ')' })}),_vm._v(" "),(!_vm.success)?_c('div',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"email-wrapper"},[_c('label',{attrs:{"for":""}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payload.email),expression:"payload.email"}],staticClass:"email-input",attrs:{"name":"email","type":"email","placeholder":"ex: name@gmail.com","required":""},domProps:{"value":(_vm.payload.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payload, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"country-wrapper"},[(_vm.countryError)?_c('div',{staticClass:"error-text"},[_vm._v("Please Choose A Country")]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"country"}},[_vm._v("Location")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.payload.country),expression:"payload.country"}],staticClass:"country-select",attrs:{"name":"country","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.payload, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Please Choose One","selected":""}},[_vm._v("Please Choose One")]),_vm._v(" "),_c('option',{attrs:{"value":"United States"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"Europe"}},[_vm._v("Europe")]),_vm._v(" "),_vm._l((_vm.availableCountries),function(country){return _c('option',{key:country.id},[_vm._v(" "+_vm._s(country.text))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"inputs"},[(_vm.codeError)?_c('div',{staticClass:"error-text"},[_vm._v("Please verify the code and try again")]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Code")]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payload.code[0]),expression:"payload.code[0]"}],staticClass:"code-input",attrs:{"type":"text","maxlength":"1","required":""},domProps:{"value":(_vm.payload.code[0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payload.code, 0, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payload.code[1]),expression:"payload.code[1]"}],staticClass:"code-input",attrs:{"type":"text","maxlength":"1","required":""},domProps:{"value":(_vm.payload.code[1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payload.code, 1, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payload.code[2]),expression:"payload.code[2]"}],staticClass:"code-input",attrs:{"type":"text","maxlength":"1","required":""},domProps:{"value":(_vm.payload.code[2])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payload.code, 2, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"dash"},[_c('span',[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payload.code[3]),expression:"payload.code[3]"}],staticClass:"code-input",attrs:{"type":"text","maxlength":"1","required":""},domProps:{"value":(_vm.payload.code[3])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payload.code, 3, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payload.code[4]),expression:"payload.code[4]"}],staticClass:"code-input",attrs:{"type":"text","maxlength":"1","required":""},domProps:{"value":(_vm.payload.code[4])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payload.code, 4, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payload.code[5]),expression:"payload.code[5]"}],staticClass:"code-input",attrs:{"type":"text","maxlength":"1","required":""},domProps:{"value":(_vm.payload.code[5])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payload.code, 5, $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"email-opt-in"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payload.email_opt_in),expression:"payload.email_opt_in"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.payload.email_opt_in)?_vm._i(_vm.payload.email_opt_in,null)>-1:(_vm.payload.email_opt_in)},on:{"change":function($event){var $$a=_vm.payload.email_opt_in,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.payload, "email_opt_in", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.payload, "email_opt_in", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.payload, "email_opt_in", $$c)}}}}),_vm._v(" "),_c('p',[_vm._v(" Stay up to date with everything American Documents")])])]),_vm._v(" "),_c('p',{staticClass:"legal"},[_vm._v("By submitting your email address above you are agreeing to the "),_c('a',{staticClass:"legal-link",attrs:{"href":"https://www.timex.com/privacy-policy.html"}},[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('a',{staticClass:"legal-link",attrs:{"href":"https://www.timex.com/terms.html"}},[_vm._v("Terms & Conditions")])]),_vm._v(" "),_c('button',{staticClass:"download-button",on:{"click":function($event){_vm.download()}}},[(!_vm.downloading)?_c('span',[_vm._v("DOWNLOAD PRINT")]):_vm._e(),_vm._v(" "),(_vm.downloading)?_c('span',[_vm._v("Downloading...")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',[_c('Check'),_vm._v(" "),_c('p',{staticClass:"legal"},[_vm._v("By submitting your email address above you are agreeing to the "),_c('a',{staticClass:"legal-link",attrs:{"href":"https://www.timex.com/privacy-policy.html"}},[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('a',{staticClass:"legal-link",attrs:{"href":"https://www.timex.com/terms.html"}},[_vm._v("Terms & Conditions")])])],1):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"image-contain"},[_c('div',{staticClass:"main-image"},[_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.data.image.image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lower-content"},[_c('div',{staticClass:"content"},[_c('h5',{staticClass:"image-title mt3 regular"},[_vm._v(_vm._s(_vm.data.image.name))]),_vm._v(" "),_c('span',{staticClass:"document-number heavy"},[_vm._v(_vm._s(_vm.data.image.document_number))])]),_vm._v(" "),(_vm.data.image.dl == 'true')?_c('div',{staticClass:"download-icon",on:{"click":function($event){_vm.openModal()}}},[_c('svg',{attrs:{"id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"100","height":"125","viewBox":"0 0 100 125","fill":"#999"}},[_c('g',{attrs:{"opacity":"1"}},[_c('path',{attrs:{"d":"M82.6 73.3v9.3H17.5v-9.3H8.1v18.5h83.7V73.3z"}}),_c('path',{attrs:{"d":"M81.6 73.3v9.3l1-1H17.5l1 1v-9.3c0-.5-.5-1-1-1H8.2c-.5 0-1 .5-1 1v18.6c0 .5.5 1 1 1h83.7c.5 0 1-.5 1-1V73.3c0-.5-.5-1-1-1h-9.3c-1.3 0-1.3 2 0 2h9.3l-1-1v18.6l1-1H8.2l1 1V73.3l-1 1h9.3l-1-1v9.3c0 .5.5 1 1 1h65.1c.5 0 1-.5 1-1v-9.3c0-1.3-2-1.3-2 0z"}}),_c('g',[_c('path',{attrs:{"d":"M36 8.1v37.2H17.5l32.5 28 32.6-28H64V8.1z"}}),_c('path',{attrs:{"d":"M35 8.1v37.2l1-1H17.4c-.8 0-1.4 1.1-.7 1.7 10.9 9.4 21.7 18.7 32.6 28 .4.4 1 .4 1.4 0 10.8-9.3 21.7-18.6 32.6-27.9.7-.6.1-1.7-.7-1.7H64l1 1V8.2c0-.5-.5-1-1-1H36.1c-1.3 0-1.3 2 0 2H64l-1-1v37.2c0 .5.5 1 1 1h18.6c-.2-.6-.5-1.1-.7-1.7C71 53.9 60.1 63.2 49.3 72.5h1.4C39.9 63.2 29 53.9 18.2 44.6c-.2.6-.5 1.1-.7 1.7h18.6c.5 0 1-.5 1-1V8.1C37 6.9 35 6.9 35 8.1z"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bottom"},_vm._l((_vm.data.pagination),function(item,index){return _c('Thumbnail',{key:index,attrs:{"data":item}})}))])])]),_vm._v("\n    "+_vm._s(_vm.state)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc2b081_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__ = __webpack_require__(143);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc2b081_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Logo: __WEBPACK_IMPORTED_MODULE_0__components_Logo__["a" /* default */] },
    name: 'app',
    data: function data() {
        return {
            isHome: this.$route.path == "/" ? true : false,
            myTest: this.$route.path == "/north" ? true : false,
            path: this.$route.path
        };
    },

    watch: {
        $route: function $route(to, from) {
            this.isHome = this.$route.path == "/" ? true : false, this.path = this.$route.path;
        }
    },
    computed: {
        showHeader: function showHeader() {
            if (this.$route.path == '/' || this.$route.path == '/north') {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        // lazyloadinit() {
        //     setTimeout( () => window.dispatchEvent(new Event('lazy-load')),300)
        // }
    },
    mounted: function mounted() {
        // this.lazyloadinit();
    }
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logo',
  data: function data() {
    return {};
  }
});

/***/ })

},[136]);


// WEBPACK FOOTER //
// static/js/app.dbc5929b48fae9c59a61.js